import { BaseApi } from '@shared/config';
import type {
  GetPaymentPeriodsRequest,
  GetPaymentPeriodsResponse,
} from './types';

class PaymentPeriodApi extends BaseApi {
  getPaymentPeriods = (
    params: GetPaymentPeriodsRequest
  ): Promise<GetPaymentPeriodsResponse> => {
    return this.instance.get('/payment-periods', { params });
  };
}

export const paymentPeriodApi = new PaymentPeriodApi();
